import { z } from "zod/v4";

import { ThemeDtoSchema } from "../../../schemas/organization";

export const PutThemeLiveRequestPathParamSchema = z.object({
  themeId: z.string(),
});

export type PutThemeLiveRequestPathParamType = z.infer<
  typeof PutThemeLiveRequestPathParamSchema
>;

export const PutThemeLiveResponseBodySchema = z.object({
  theme: ThemeDtoSchema,
});

export type PutThemeLiveResponseBodyType = z.infer<
  typeof PutThemeLiveResponseBodySchema
>;
